<template>

<div>
  <b-navbar toggleable="lg" type="light" variant="light">
    <b-navbar-brand href="#/">
      <img class="d-inline-block align-bottom" src="@/assets/navbar-brand.png" height="80" width="auto"/>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse class="vertical-align:bottom;" id="nav-collapse" is-nav>
      <b-navbar-nav >
        <b-nav-item href="#/" >
          Home
        </b-nav-item>
        <b-nav-item-dropdown text="Datasets">
          <b-dropdown-item href="#/datasets/anatomist">
            Digital Anatomist
          </b-dropdown-item>
          <b-dropdown-item href="#/datasets/zoo">
            Digital Brain Zoo
          </b-dropdown-item>
          <b-dropdown-item href="#/datasets/pathologist">
            Digital Pathologist
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item href="#/tileviewer">
          Viewer
        </b-nav-item>
        <b-nav-item href="#/contributors">
          Contributors
        </b-nav-item>
        <b-nav-item href="#/about">
          About
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>

    <img class="d-inline-block align-bottom" src="@/assets/uoo.png" height="80" width="auto"/>
  </b-navbar>
</div>
  
</template>

<script>
export default {
  name: "navigation"
  
}
</script>

<style scoped>

</style>
